export default {
    title: "Hogar",
    button: {
        accessories: "Explorar catálogo"
    },
    noAvailableItems: "El Portal Periférico no tiene artículos disponibles para su país en este momento. Trabaje con su gerente para adquirir los artículos que necesita.<br><br> <a href='#' role='button' data-widget-trigger='{widgetOptions}'>Soporte de contacto</a>",
    error: "Hubo un problema al recuperar los productos. Por favor refresque su navegador."
}